import getStore from '../store/store';
import { mutator } from 'satcheljs';
import {
    type OWA_MODULE_SET_DRAGGED_ITEM_TYPEActionMessage,
    setDraggedItemType,
} from '../actions/setDraggedItemType';

export const setDraggedItemTypeMutator: (
    actionMessage: OWA_MODULE_SET_DRAGGED_ITEM_TYPEActionMessage
) => void =
    // eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- BASELINE, DO NOT COPY!
    mutator(setDraggedItemType, actionMessage => {
        getStore().draggedItemType = actionMessage.typeOfItemDragged;
    });
